(() => {
  if (window.bf26) return

  const STORAGE_KEY = "bf26_entry"
  const COOKIE = "bf26_vip"
  const ARM_COOKIE = "bf26_arm"

  function pad(n) {
    return String(Math.max(0, n)).padStart(2, "0")
  }

  function remaining(target) {
    const ms = Math.max(0, new Date(target).getTime() - Date.now())
    const seconds = Math.floor(ms / 1000)
    const minutes = Math.floor(seconds / 60)
    return {
      done: ms <= 0,
      days: Math.floor(minutes / 1440),
      hours: Math.floor((minutes % 1440) / 60),
      minutes: minutes % 60,
      seconds: seconds % 60
    }
  }

  function renderCountdown(el) {
    const target = el.dataset.bf26Countdown
    if (!target || isNaN(new Date(target).getTime())) return
    const left = remaining(target)
    for (const unit of el.querySelectorAll("[data-unit]")) {
      const value = pad(left[unit.dataset.unit])
      if (unit.textContent === value) continue
      const tile = unit.closest(".bf26-unit")
      if (unit.textContent && tile && unit.dataset.unit !== "seconds") {
        tile.classList.remove("is-flipping")
        void tile.offsetWidth
        tile.classList.add("is-flipping")
      }
      unit.textContent = value
    }
    for (const text of el.querySelectorAll("[data-countdown-text]")) {
      const parts = [left.days + "d", pad(left.hours) + "h"]
      if (text.dataset.countdownText !== "short") parts.push(pad(left.minutes) + "m")
      text.textContent = parts.join(" ")
    }
    el.classList.toggle("is-done", left.done)
  }

  function tick() {
    for (const el of document.querySelectorAll("[data-bf26-countdown]")) {
      renderCountdown(el)
    }
  }

  function config() {
    const el = document.getElementById("bf26-config")
    let data = {}
    if (el) {
      try {
        data = JSON.parse(el.textContent)
      } catch (e) {}
    }
    const params = new URLSearchParams(location.search)
    data.test = Boolean(data.test || params.has("bf26_test") || window.Shopify?.designMode)
    return data
  }

  function markEntered(arm) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ at: Date.now(), arm }))
    } catch (e) {}
    const age = `path=/; max-age=${60 * 60 * 24 * 90}; samesite=lax`
    document.cookie = `${COOKIE}=1; ${age}`
    if (arm) document.cookie = `${ARM_COOKIE}=${arm}; ${age}`
  }

  function enteredArm() {
    const cookie = document.cookie.split("; ").find(c => c.startsWith(`${ARM_COOKIE}=`))
    if (cookie) return cookie.split("=")[1]
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}").arm || null
    } catch (e) {
      return null
    }
  }

  function hasEntered() {
    if (document.cookie.split("; ").includes(`${COOKIE}=1`)) return true
    try {
      return Boolean(localStorage.getItem(STORAGE_KEY))
    } catch (e) {
      return false
    }
  }

  async function submit(email, cfg) {
    if (cfg.test) return true
    if (!cfg.formspreeId) throw new Error("bf26: no Formspree form ID set on the loader section")
    const res = await fetch(`https://formspree.io/f/${encodeURIComponent(cfg.formspreeId)}`, {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json"
      },
      body: JSON.stringify({ email, variant: cfg.arm || "a", source: cfg.source || "BF26 VIP Giveaway", page: location.pathname, entered_at: new Date().toISOString() })
    })
    if (!res.ok) throw new Error(`Formspree submission failed: ${res.status}`)
    return true
  }

  async function enter(form) {
    const input = form.querySelector('input[type="email"]')
    const button = form.querySelector('[type="submit"]')
    const email = input.value.trim()
    form.classList.remove("has-error")
    if (!input.checkValidity() || !email) {
      form.classList.add("has-error")
      input.focus()
      return
    }
    const cfg = config()
    button?.setAttribute("loading", "")
    let ok = false
    try {
      ok = await submit(email, cfg)
    } catch (e) {
      console.error("bf26 entry:", e)
      ok = false
    }
    button?.removeAttribute("loading")
    if (!ok) {
      const error = form.querySelector(".bf26-form-error")
      if (error) error.textContent = "Something went wrong. Please try again."
      form.classList.add("has-error")
      return
    }
    markEntered(cfg.arm || "a")
    const event = new CustomEvent("bf26:entered", { cancelable: true, detail: { redirect: cfg.redirect, arm: cfg.arm || "a" } })
    if (document.dispatchEvent(event) && cfg.redirect && !cfg.test) {
      location.href = cfg.redirect
    }
  }

  function scrollToEntry() {
    const form = document.querySelector("[data-bf26-entry]")
    if (!form) return
    const input = form.querySelector('input[type="email"]')
    form.scrollIntoView({ behavior: "smooth", block: "center" })
    setTimeout(() => input?.focus({ preventScroll: true }), 600)
  }

  function initReveal() {
    const items = document.querySelectorAll(".bf26-reveal:not(.is-visible), [data-bf26-trace]:not(.is-visible)")
    if (!("IntersectionObserver" in window)) {
      for (const item of items) item.classList.add("is-visible")
      return
    }
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add("is-visible")
        observer.unobserve(entry.target)
      }
    }, { rootMargin: "0px 0px -10% 0px" })
    for (const item of items) observer.observe(item)
  }

  document.addEventListener("submit", e => {
    const form = e.target.closest("[data-bf26-entry]")
    if (!form) return
    e.preventDefault()
    enter(form)
  })

  function toggleFaq(button) {
    const item = button.parentElement
    const open = !item.classList.contains("is-open")
    if (open) {
      for (const other of item.parentElement.querySelectorAll(":scope > .is-open")) {
        other.classList.remove("is-open")
        other.querySelector("[data-bf26-faq-toggle]")?.setAttribute("aria-expanded", "false")
      }
    }
    item.classList.toggle("is-open", open)
    button.setAttribute("aria-expanded", String(open))
  }

  function expand(button) {
    const wrap = button.closest(".wall-wrap")
    if (!wrap || wrap.classList.contains("is-expanding")) return
    wrap.style.maxHeight = wrap.offsetHeight + "px"
    void wrap.offsetHeight
    wrap.classList.add("is-expanding")
    wrap.style.maxHeight = wrap.scrollHeight + "px"
    function done() {
      wrap.removeEventListener("transitionend", onEnd)
      wrap.classList.add("is-expanded")
      wrap.style.maxHeight = ""
    }
    function onEnd(e) {
      if (e.target === wrap && e.propertyName === "max-height") done()
    }
    wrap.addEventListener("transitionend", onEnd)
    setTimeout(() => {
      if (!wrap.classList.contains("is-expanded")) done()
    }, 1600)
  }

  function loadLibrary(test, src, css) {
    if (test()) return Promise.resolve()
    if (css && !document.querySelector(`link[href="${css}"]`)) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = css
      document.head.append(link)
    }
    return new Promise(resolve => {
      const script = document.createElement("script")
      script.src = src
      script.onload = resolve
      script.onerror = resolve
      document.head.append(script)
    })
  }

  function libraries() {
    if (document.querySelector(".bf26 .fluid-marquee") && !document.querySelector('script[src*="fluid-marquee"]')) {
      loadLibrary(() => window.FluidMarquee, "https://cdn.jsdelivr.net/npm/fluid-marquee@1.2.0/dist/fluid-marquee.min.js", "https://cdn.jsdelivr.net/npm/fluid-marquee@1.2.0/dist/fluid-marquee.min.css").then(() => window.FluidMarquee?.initAll())
    }
    if (document.querySelector(".bf26 [data-popupable]")) {
      loadLibrary(() => window.popupableAnimTypes, "https://cdn.jsdelivr.net/npm/popupable@1.11.0/dist/popupable.min.js", "https://cdn.jsdelivr.net/npm/popupable@1.11.0/dist/popupable.min.css")
    }
  }

  let rulesDialog = null

  function rulesModal(href) {
    if (rulesDialog) return rulesDialog
    rulesDialog = document.createElement("dialog")
    rulesDialog.className = "bf26 bf26-rules"
    rulesDialog.setAttribute("aria-labelledby", "bf26-rules-title")
    rulesDialog.innerHTML = `
      <div class="rules-head">
        <div>
          <div class="rules-eyebrow">The Forward Bar BFCM Sweepstakes</div>
          <h2 class="rules-title" id="bf26-rules-title">Official Rules</h2>
        </div>
        <button class="rules-close" type="button" aria-label="Close" data-bf26-rules-close></button>
      </div>
      <div class="rules-scroll" data-bf26-rules-scroll><div class="rules-loading">Loading the Official Rules...</div></div>
    `
    document.body.append(rulesDialog)
    const url = new URL(href, location.origin)
    url.searchParams.set("section_id", "ante-bf26-rules")
    fetch(url).then(res => {
      if (!res.ok) throw new Error(`Official Rules failed to load: ${res.status}`)
      return res.text()
    }).then(html => {
      const content = new DOMParser().parseFromString(html, "text/html").querySelector("[data-bf26-rules-content]")
      if (!content) throw new Error("Official Rules section returned no content")
      rulesDialog.querySelector("[data-bf26-rules-scroll]").replaceWith(content)
    }).catch(e => {
      console.error("bf26 rules:", e)
      rulesDialog.remove()
      rulesDialog = null
      location.href = href
    })
    return rulesDialog
  }

  function toggleRule(button) {
    const item = button.closest(".rules-item")
    const open = !item.classList.contains("is-open")
    for (const other of item.parentElement.querySelectorAll(".rules-item.is-open")) {
      other.classList.remove("is-open")
      other.querySelector("[data-bf26-rules-toggle]").setAttribute("aria-expanded", "false")
    }
    item.classList.toggle("is-open", open)
    button.setAttribute("aria-expanded", String(open))
  }

  document.addEventListener("click", e => {
    const rules = e.target.closest('a[href*="official-rules"]')
    if (rules && !e.metaKey && !e.ctrlKey && !e.shiftKey && rules.pathname !== location.pathname) {
      e.preventDefault()
      rulesModal(rules.href).showModal()
      return
    }
    const rulesBox = e.target.closest(".bf26-rules")
    if (rulesBox) {
      const box = rulesBox.getBoundingClientRect()
      const outside = e.target === rulesBox && (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom)
      if (outside || e.target.closest("[data-bf26-rules-close]")) {
        rulesBox.close()
        return
      }
    }
    const rule = e.target.closest("[data-bf26-rules-toggle]")
    if (rule) {
      toggleRule(rule)
      return
    }
    if (e.target.closest("[data-bf26-scroll-entry]")) {
      e.preventDefault()
      scrollToEntry()
      return
    }
    const more = e.target.closest("[data-bf26-expand]")
    if (more) {
      expand(more)
      return
    }
    const faq = e.target.closest("[data-bf26-faq-toggle]")
    if (faq) toggleFaq(faq)
  })

  window.bf26 = { tick, hasEntered, enteredArm, markEntered, config, initReveal, remaining }

  function start() {
    tick()
    initReveal()
    libraries()
    setInterval(tick, 1000)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start)
  } else {
    start()
  }

  document.addEventListener("shopify:section:load", () => {
    tick()
    initReveal()
    libraries()
  })
})()
